"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserPersonalData = exports.purchaseorderThankyouRedirection = exports.isSignatureCustomer = exports.getSignatuerContractType = exports.isNutritionFeatureOn = exports.getB2bDetails = exports.getPoeDetails = exports.isAppleDevice = exports.showOnDeviceWearablePPU = exports.isNewWLSCustomerFlow = exports.isHOGMessageInCart = exports.isUPFlow = exports.isBSSEShippingAddrHasError = exports.isFirstNetFlowForLosgId = exports.isFirstNetCaribbean = exports.IsWirelessFirstNetFlow = exports.isFirstNetFlow = exports.isAccessoryOnlyInCart = exports.getSubFlowTypeForHeaders = exports.isAccessoryEligibleFlow = exports.isBsseAccessoryFlow = exports.isWireLineBrePromo = exports.checkBusinessType = exports.isBusinessTypeReconnect = exports.isHylaItemAvail = exports.isConnectedCarFlow = exports.isPaymentExpressView = exports.isSMBNewStandaloneBroadbandFlow = exports.isSMBNewBBSelected = exports.SVG_ICONS = exports.GET_ICON_URL = exports.cartHasBroadbandABPDiscount = exports.rewardCardAvailable = exports.applyRewardCardPromo = exports.isStandaloneBroadbandInCart = exports.getSmartyStreetKey = exports.isAutoPayPaymentMerged = exports.getLOSGItemsforWireline = exports.isUPOrAALFlow = exports.isValidEDSPFlow = exports.isSMBBBCustomerFlow = exports.isBusinessAppsFlow = exports.isSMBNewBBCustomerFlow = exports.isSMBNEWAiaBCustomerFlow = exports.isSMBNewCustomerFlow = exports.isValidSMBCustomer = exports.IsEmployeeOfferAvailable = exports.isExpressUpgradeViewEnabled = exports.neustarApiCall = exports.isNotWlsWithUPGOrAALFlow = exports.isMyATTApp = exports.isIOS = exports.getMigrationSource = exports.getCookie = exports.getHardStopperText = exports.getResponseErrorHardStopperText = exports.handleCreditRespError = exports.checkCreditCheckStatusAndRedirect = exports.formatCreditInformationResponse = exports.getPriceBarData = exports.getPriceDataForPrepaidFlow = exports.formmatedMultiAddressArray = exports.getSelectedUpgradeOption = exports.isCartIxpFeatureEnabled = exports.isCheckoutIxpFeatureEnabled = exports.getIxpFeatureFlagValue = exports.isIxpFeatureEnabled = exports.getLosgCount = exports.getDisplayNameWithSKU = exports.getCurrentWirelessPlanFromCart = exports.getLineItemWithSKU = exports.getLOSGItemWithSKU = exports.getauthenticatedPersistantLoginURL = exports.isLoginRequiredonCart = exports.getMitigationDetails = exports.getUpgradeAmount = exports.isAuthenticatedWirelessFlow = exports.isExistingDTVNWithBB = exports.getDonartionAmount = exports.getAuthUserState = exports.isExistingBBWithDTVN = exports.isDeviceTradeInApplicable = exports.isAALFlow = exports.getThePaymentMethodDesc = exports.creditCardMod10Check = exports.returnOtherValueInNotFound = exports.IsUSTerritoryNeedtoHide = exports.isExistingWirelessCustomerAndHavingBroadbandInCart = exports.isAccessIDEnabledFeatureToggle = exports.checkDay = exports.getDay = exports.dateFormatDayMonthDDYYYY = exports.DayOfWeek = exports.isAIABFlow = exports.getLosgSequence = exports.getLineItemType = exports.getDisplayName = exports.getLineItem = exports.getLOSGItems = exports.getLOSGItem = exports.utilCheckCMSContent = exports.getCurrentLOBNameSpace = exports.getBundlesZipCodeForCKAV = exports.getZipCodeForCKAV = exports.isOrderSubmitted = exports.getCkavCheckoutStorageData = exports.getCkavStorageData = exports.isCheckAvailabilityRequired = exports.removeArrayElementByIndex = exports.amountWithDecimal = exports.getInitialHeaders = exports.replaceSpecialChatWithHTMLChars = exports.formatCreditCardWithSpaces = exports.formatPhoneNumberWithDecimal = exports.formatPhoneNumberWithDot = exports.setSelectedStoreCookie = exports.setPersonalizationCookie = exports.getCustomerState = exports.isHISALOBsOnly = exports.getCurrentLOB = exports.isPrepaidFlowType = exports.getCurrentFlowType = exports.getOrderSubType = exports.getCustomerContractTypeFromCart = exports.IsHBOMaxCharged = exports.IsStandaloneBusinessToolsInCart = exports.IsBroadbandInCart = exports.IsSONOSAccessoryInCart = exports.isHboFreeWithWireless = exports.isHboFreeWithBroadband = exports.IsHboMaxInCart = exports.IsIPTVInCart = exports.IsDTVSInCart = exports.isStandaloneDTVSInCart = exports.IsDtvnowEDSPFlow = exports.IsBBTVInCart = exports.IsStandaloneDTVNOWInCart = exports.IsDTVNOWInCart = exports.isAuthuser = exports.IsWirelessOnlyInCart = exports.IsWirelessInCart = exports.getBillCycleDay = exports.isBsseWirelessFlow = exports.IsBsseFlow = exports.isShoppingCartRendered = exports.isThisLOBInMetaData = exports.isCartReadytoCheckout = exports.getLobList = exports.getCartStatus = exports.getCartResp = exports.getCartResponse = exports.rejectHTTPErrors = exports.strictMobileViewport = exports.isMobile = void 0;
// tslint:disable:max-file-line-count
// tslint:disable:max-line-length
var StateProvider_1 = require("../api/StateProvider");
var localdatastore_1 = require("../config/localdatastore");
var CommonUtilFuntions_1 = require("./CommonUtilFuntions");
var cms_integration_1 = require("@idp/cms-integration");
var Checkout_cms_1 = require("../cms/Checkout.cms");
var CheckoutConstants_1 = require("./CheckoutConstants");
var NON_DESKTOP_BREAKPOINT = 1024;
var NON_TABLET_BREAKPOINT = 767;
var phoneRegex = new RegExp('^[0-9() ]*$');
var payCardRegex = new RegExp('^(([0-9 ]*)|([X ]*[0-9]{4}))$');
var numbersOnlyRegex = new RegExp('^(([0-9]*)|([X ]*[0-9]{4}))$');
var headers = [
    {
        name: 'Accept',
        value: 'application/json,*/*',
    },
];
exports.isMobile = function () {
    return (window.innerWidth <= NON_DESKTOP_BREAKPOINT);
};
exports.strictMobileViewport = function () {
    return (window.innerWidth <= NON_TABLET_BREAKPOINT);
};
function rejectHTTPErrors(res) {
    return (res.status >= 400) ? res.json().then(Promise.reject.bind(Promise)) : Promise.resolve(res);
}
exports.rejectHTTPErrors = rejectHTTPErrors;
function getCartResponse() {
    var cartResponse = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('APPSHELL'), 'cartResponse');
    if (cartResponse && cartResponse.content && cartResponse.content.payload) {
        return cartResponse;
    }
    else {
        return null;
    }
}
exports.getCartResponse = getCartResponse;
function getCartResp() {
    var cartResponse = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('APPSHELL'), 'cartResponse');
    if (cartResponse && cartResponse.content && cartResponse.content.payload) {
        return cartResponse.content.payload;
    }
    else {
        return null;
    }
}
exports.getCartResp = getCartResp;
function getCartStatus() {
    var _a;
    var payload = getCartResp();
    return (payload === null || payload === void 0 ? void 0 : payload.cartStatus) ? payload === null || payload === void 0 ? void 0 : payload.cartStatus : ((payload === null || payload === void 0 ? void 0 : payload.commonCart) ? (_a = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _a === void 0 ? void 0 : _a.cartStatus : undefined);
}
exports.getCartStatus = getCartStatus;
function getLobList() {
    var _a, _b;
    var lobList = [];
    var payload = getCartResp();
    if (payload && payload.commonCart && payload.commonCart.losgs) {
        Object.values(payload.commonCart.losgs).filter(function (value) {
            return lobList.push(value.productCategory);
        });
    }
    else {
        lobList = (((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.lobList) ? payload.metadata.metadata.lobList : []);
    }
    return lobList;
}
exports.getLobList = getLobList;
function isCartReadytoCheckout() {
    var cartStatus = getCartStatus();
    return !!(cartStatus && cartStatus.readyToCheckout);
}
exports.isCartReadytoCheckout = isCartReadytoCheckout;
function isThisLOBInMetaData(lobName) {
    var lobList = getLobList();
    return !!(lobList && lobList.indexOf(lobName) !== -1);
}
exports.isThisLOBInMetaData = isThisLOBInMetaData;
function isShoppingCartRendered() {
    var _a, _b, _c, _d;
    var cartSummaryResp = getCartResponse();
    return !!(((_d = (_c = (_b = (_a = cartSummaryResp === null || cartSummaryResp === void 0 ? void 0 : cartSummaryResp.content) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.wirelessCart) === null || _c === void 0 ? void 0 : _c._cartPageurl) === null || _d === void 0 ? void 0 : _d.indexOf('shoppingcart')) > -1);
}
exports.isShoppingCartRendered = isShoppingCartRendered;
function IsBsseFlow() {
    var _a, _b;
    var flowType = false;
    var payload = getCartResp();
    if ((_a = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        flowType = Object.values(payload.commonCart.losgs).filter(function (value) {
            return value.billingSystemId === 'R';
        }).length > 0;
    }
    else if ((_b = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _b === void 0 ? void 0 : _b.losgs) {
        flowType = Object.values(payload.wirelessCart.losgs).filter(function (value) {
            return value.billingSystemId === 'R';
        }).length > 0;
    }
    return flowType;
}
exports.IsBsseFlow = IsBsseFlow;
function isBsseWirelessFlow() {
    var _a;
    var flowType = false;
    var payload = getCartResp();
    if (((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a._bsseWirelessFlow) &&
        !isCheckoutIxpFeatureEnabled('svc-disable-checkout-bsse-billestimator')) {
        flowType = true;
    }
    return flowType;
}
exports.isBsseWirelessFlow = isBsseWirelessFlow;
function getBillCycleDay() {
    var _a, _b, _c, _d;
    var day = 0;
    var payload = getCartResp();
    if ((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _a === void 0 ? void 0 : _a.account) === null || _b === void 0 ? void 0 : _b.billCycleDay) {
        day = payload.commonCart.account.billCycleDay;
    }
    else if ((_d = (_c = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _c === void 0 ? void 0 : _c.account) === null || _d === void 0 ? void 0 : _d.billCycleDay) {
        day = payload.wirelessCart.account.billCycleDay;
    }
    return day;
}
exports.getBillCycleDay = getBillCycleDay;
function IsWirelessInCart() {
    var _a;
    var exist = false;
    var payload = getCartResp();
    if ((_a = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        exist = Object.values(payload.commonCart.losgs).filter(function (value) {
            return value.productCategory === CheckoutConstants_1.LOBNames.LOB_WIRELESS;
        }).length > 0;
    }
    else {
        exist = !!(isThisLOBInMetaData(CheckoutConstants_1.LOBNames.LOB_WIRELESS)
            && payload.wirelessCart);
    }
    return exist;
}
exports.IsWirelessInCart = IsWirelessInCart;
function IsWirelessOnlyInCart() {
    var retVal = false;
    var lobList = getLobList();
    if (lobList.length === 1 &&
        lobList.indexOf('WIRELESS') !== -1 &&
        IsWirelessInCart()) {
        retVal = true;
    }
    return retVal;
}
exports.IsWirelessOnlyInCart = IsWirelessOnlyInCart;
function isAuthuser() {
    var payload = getCartResp();
    return !!(payload && payload.authUser);
}
exports.isAuthuser = isAuthuser;
function IsDTVNOWInCart() {
    var payload = getCartResp();
    return !!(isThisLOBInMetaData(CheckoutConstants_1.LOBNames.LOB_DTV_NOW)
        && payload.dtvnowCart);
}
exports.IsDTVNOWInCart = IsDTVNOWInCart;
function IsStandaloneDTVNOWInCart() {
    var payload = getCartResp();
    var lobList = getLobList();
    return !!(lobList && lobList.length === 1
        && lobList.indexOf(CheckoutConstants_1.LOBNames.LOB_DTV_NOW) !== -1
        && payload.dtvnowCart);
}
exports.IsStandaloneDTVNOWInCart = IsStandaloneDTVNOWInCart;
function IsBBTVInCart() {
    var payload = getCartResp();
    return !!(payload && payload.metadata && payload.metadata.metadata
        && payload.metadata.metadata.dtvMetadata
        && payload.metadata.metadata.dtvMetadata.contractOffer);
}
exports.IsBBTVInCart = IsBBTVInCart;
function IsDtvnowEDSPFlow() {
    var payload = getCartResp();
    return !!(payload && payload.dtvnowCart && payload.dtvnowCart.contractType &&
        payload.dtvnowCart.contractType === 'EDSP');
}
exports.IsDtvnowEDSPFlow = IsDtvnowEDSPFlow;
function isStandaloneDTVSInCart() {
    var retVal = false;
    var payload = getCartResp();
    var lobList = getLobList();
    if (lobList && lobList.length === 1 &&
        lobList.indexOf('DTVS') !== -1 &&
        payload.dtvsCart) {
        retVal = true;
    }
    return retVal;
}
exports.isStandaloneDTVSInCart = isStandaloneDTVSInCart;
function IsDTVSInCart() {
    var payload = getCartResp();
    return !!(isThisLOBInMetaData(CheckoutConstants_1.LOBNames.LOB_DTVS) && payload.dtvsCart);
}
exports.IsDTVSInCart = IsDTVSInCart;
function IsIPTVInCart() {
    var payload = getCartResp();
    return !!(isThisLOBInMetaData(CheckoutConstants_1.LOBNames.LOB_IPTV) && payload.iptvCart);
}
exports.IsIPTVInCart = IsIPTVInCart;
function IsHboMaxInCart() {
    var payload = getCartResp();
    var isBroadbandWithHbomax = !!(payload.broadbandCart &&
        payload.broadbandCart.entitlementBenefit && payload.broadbandCart.entitlementBenefit.toUpperCase() === 'HBOMAX');
    return !!((isThisLOBInMetaData(CheckoutConstants_1.LOBNames.LOB_HBOMAX) && (payload.hbomaxCart ||
        isHboFreeWithBroadband() || isHboFreeWithWireless())) || isBroadbandWithHbomax);
}
exports.IsHboMaxInCart = IsHboMaxInCart;
function isHboFreeWithBroadband() {
    var payload = getCartResp();
    return !!(payload.broadbandCart
        && payload.broadbandCart.hbomaxType
        && payload.broadbandCart.hbomaxType === 'FREE');
}
exports.isHboFreeWithBroadband = isHboFreeWithBroadband;
function isHboFreeWithWireless() {
    var payload = getCartResp();
    return !!(payload.wirelessCart
        && payload.wirelessCart.hbomaxType
        && payload.wirelessCart.hbomaxType === 'FREE');
}
exports.isHboFreeWithWireless = isHboFreeWithWireless;
function IsSONOSAccessoryInCart() {
    var payload = getCartResp();
    return !!(isThisLOBInMetaData(CheckoutConstants_1.LOBNames.LOB_ACCESSORY)
        && payload.accessoryCart);
}
exports.IsSONOSAccessoryInCart = IsSONOSAccessoryInCart;
function IsBroadbandInCart() {
    var payload = getCartResp();
    return (!!(isThisLOBInMetaData(CheckoutConstants_1.LOBNames.LOB_BROADBAND) && payload.broadbandCart) ||
        IsStandaloneBusinessToolsInCart());
}
exports.IsBroadbandInCart = IsBroadbandInCart;
function IsStandaloneBusinessToolsInCart() {
    var payload = getCartResp();
    return !!(isThisLOBInMetaData(CheckoutConstants_1.LOBNames.LOB_BUSINESSAPPS) && payload.businessAppCart &&
        (!isThisLOBInMetaData(CheckoutConstants_1.LOBNames.LOB_BROADBAND) && !payload.broadbandCart));
}
exports.IsStandaloneBusinessToolsInCart = IsStandaloneBusinessToolsInCart;
function IsHBOMaxCharged() {
    var payload = getCartResp();
    return !!(payload
        && payload.hbomaxCart && payload.hbomaxCart.totalLobDueMonthly
        && payload.hbomaxCart.totalLobDueMonthly > 0);
}
exports.IsHBOMaxCharged = IsHBOMaxCharged;
function getCustomerContractTypeFromCart() {
    var payload = getCartResp();
    if (payload
        && payload.b2bDetail
        && payload.b2bDetail.customerContractSubType) {
        return payload.b2bDetail.customerContractSubType;
    }
    else {
        return '';
    }
}
exports.getCustomerContractTypeFromCart = getCustomerContractTypeFromCart;
function getOrderSubType() {
    var payload = getCartResp();
    var flowType;
    if (payload && payload.commonCart) {
        Object.values(payload.commonCart.losgs).filter(function (value) {
            return flowType = value.losgType + '_' + value.productCategory;
        });
    }
    else {
        flowType = (payload &&
            payload.metadata && payload.metadata.metadata
            && payload.metadata.metadata.orderSubType);
    }
    return flowType;
}
exports.getOrderSubType = getOrderSubType;
function getCurrentFlowType() {
    var payload = getCartResp();
    if (payload && payload.metadata && payload.metadata.metadata &&
        payload.metadata.metadata.wirelessMetadata &&
        payload.metadata.metadata.wirelessMetadata.paymentType) {
        return payload.metadata.metadata.wirelessMetadata.paymentType;
    }
    return getOrderSubType();
}
exports.getCurrentFlowType = getCurrentFlowType;
function isPrepaidFlowType() {
    var wirelessDetails = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('APPSHELL'), 'wirelessDetails');
    if (wirelessDetails && wirelessDetails.wirelessType) {
        return wirelessDetails.wirelessType.toUpperCase() === CheckoutConstants_1.FlowType.WIRELESS_PREPAID;
    }
    return false;
}
exports.isPrepaidFlowType = isPrepaidFlowType;
function getCurrentLOB() {
    var lobList = getLobList();
    return (lobList && lobList.length > 0) ? lobList[0] : null;
}
exports.getCurrentLOB = getCurrentLOB;
function isHISALOBsOnly() {
    return !!(IsBroadbandInCart() || IsDTVSInCart() || IsIPTVInCart());
}
exports.isHISALOBsOnly = isHISALOBsOnly;
function getCustomerState() {
    var currentCustomerState = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'currentCustomerState');
    return (currentCustomerState && currentCustomerState.customerState);
}
exports.getCustomerState = getCustomerState;
function setPersonalizationCookie(zip) {
    var name = 'attPersistantLocalization' + '=';
    var decodedCookie = decodeURIComponent(document.cookie).split(';');
    var cookieVal = '';
    decodedCookie.forEach(function (c) {
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            cookieVal = c.substring(name.length, c.length);
        }
    });
    if (cookieVal) {
        cookieVal = cookieVal.split('|').map(function (part) {
            if (part.indexOf('zip') > -1) {
                return 'zip=' + zip;
            }
            else {
                return part;
            }
        }).join('|');
        if (cookieVal.indexOf('zip') === -1) {
            cookieVal += '|zip=' + zip;
        }
    }
    if (!cookieVal) {
        cookieVal = 'zip=' + zip;
    }
    var d = new Date();
    d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    document.cookie = name + cookieVal + ';' + expires + ';path=/';
}
exports.setPersonalizationCookie = setPersonalizationCookie;
function setSelectedStoreCookie(zip, id) {
    var name = 'selectedstore' + '=';
    var cookieVal = '';
    var decodedCookie = decodeURIComponent(document.cookie).split(';');
    decodedCookie.forEach(function (c) {
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            cookieVal = c.substring(name.length, c.length);
        }
    });
    if (cookieVal) {
        cookieVal = cookieVal.split('|').map(function (part) {
            if (part.indexOf('selectedzip') > -1) {
                return 'selectedzip=' + zip;
            }
            else if (part.indexOf('storeinvid') > -1) {
                return 'storeinvid=' + id;
            }
            else {
                return part;
            }
        }).join('|');
        if (cookieVal.indexOf('storeinvid') === -1) {
            cookieVal += 'storeinvid=' + id;
        }
        if (cookieVal.indexOf('selectedzip') === -1) {
            cookieVal += '|selectedzip=' + zip;
        }
    }
    else {
        cookieVal = 'storeinvid=' + id;
        cookieVal += '|';
        cookieVal += 'selectedzip=' + zip;
    }
    document.cookie = name + cookieVal + ';path=/';
}
exports.setSelectedStoreCookie = setSelectedStoreCookie;
function formatPhoneNumberWithDot(value) {
    var tempNumber;
    if (value && value.length > 0 && phoneRegex.test(value)) {
        tempNumber = value.replace(/[^0-9]/g, '');
    }
    else {
        return value;
    }
    if (tempNumber && tempNumber.length > 3 && tempNumber.length < 7) {
        return tempNumber.replace(/(\d{3})(\d*)/, '(' + '$1' + ') ' + '$2');
    }
    else if (tempNumber && tempNumber.length > 6 && tempNumber.length < 11) {
        return tempNumber.replace(/(\d{3})(\d{3})(\d*)/, '(' + '$1' + ') ' + '$2' + '-' + '$3');
    }
    else {
        return value;
    }
}
exports.formatPhoneNumberWithDot = formatPhoneNumberWithDot;
function formatPhoneNumberWithDecimal(value) {
    var tempNumber;
    if (value && value.length > 0 && phoneRegex.test(value)) {
        tempNumber = value.replace(/[^0-9]/g, '');
    }
    else {
        return value;
    }
    if (tempNumber && tempNumber.length > 3 && tempNumber.length < 7) {
        return tempNumber.replace(/(\d{3})(\d*)/, '$1' + '.' + '$2');
    }
    else if (tempNumber && tempNumber.length > 6 && tempNumber.length < 11) {
        return tempNumber.replace(/(\d{3})(\d{3})(\d*)/, '$1' + '.' + '$2' + '.' + '$3');
    }
    else {
        return value;
    }
}
exports.formatPhoneNumberWithDecimal = formatPhoneNumberWithDecimal;
function formatCreditCardWithSpaces(value) {
    var tempNumber;
    if (value && value.length > 0 && payCardRegex.test(value)) {
        tempNumber = value.indexOf(' ') > 0 ? value.replace(/[^0-9]/g, '') : value;
    }
    else {
        return value;
    }
    if (tempNumber && tempNumber.length > 4 && tempNumber.length < 9 && numbersOnlyRegex.test(tempNumber)) {
        return tempNumber.substring(0, 4) + " " + tempNumber.substring(4, tempNumber.length);
    }
    else if (tempNumber && tempNumber.length > 8 && tempNumber.length < 13 && numbersOnlyRegex.test(tempNumber)) {
        return tempNumber.substring(0, 4) + " " + tempNumber
            .substring(4, 8) + " " + tempNumber.substring(8, tempNumber.length);
    }
    else if (tempNumber && tempNumber.length > 12 && tempNumber.length < 15 && numbersOnlyRegex.test(tempNumber)) {
        return tempNumber.substring(0, 4) + " " + tempNumber
            .substring(4, 8) + " " + tempNumber.substring(8, 12) + " " + tempNumber.substring(12, tempNumber.length);
    }
    else if (tempNumber && tempNumber.length === 16 && numbersOnlyRegex.test(tempNumber)) {
        return tempNumber.substring(0, 4) + " " + tempNumber
            .substring(4, 8) + " " + tempNumber.substring(8, 12) + " " + tempNumber.substring(12, 16);
    }
    else if (tempNumber && tempNumber.length === 15 && numbersOnlyRegex.test(tempNumber)) {
        return tempNumber.substring(0, 4) + " " + tempNumber
            .substring(4, 10) + " " + tempNumber.substring(10, 15);
    }
    else {
        return value;
    }
}
exports.formatCreditCardWithSpaces = formatCreditCardWithSpaces;
function replaceSpecialChatWithHTMLChars(value) {
    if (value) {
        return value.replace(/&/g, '&').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    }
    else {
        return value;
    }
}
exports.replaceSpecialChatWithHTMLChars = replaceSpecialChatWithHTMLChars;
function getInitialHeaders() {
    var defaultHeaders = new Headers();
    var subFlowType = getSubFlowTypeForHeaders();
    headers.forEach(function (header) {
        defaultHeaders.append(header.name, header.value);
    });
    if (getCurrentFlowType()) {
        defaultHeaders.append('idp-source', getCurrentFlowType());
    }
    if (isMyATTApp()) {
        defaultHeaders.append('idp-device-source', 'myATTApp');
    }
    if (subFlowType) {
        defaultHeaders.append('idp-subFlowType', subFlowType);
    }
    var stateCsrfToken = StateProvider_1.StateProvider.getStateManagerInstance().get('appShell', 'csrf-token');
    if (stateCsrfToken && stateCsrfToken.value) {
        defaultHeaders.append('X-CSRF-TOKEN', stateCsrfToken.value);
    }
    var campaignId = StateProvider_1.StateProvider.getStateManagerInstance().get('appShell', 'campaignId');
    if (campaignId && campaignId.value) {
        defaultHeaders.append('idp-campaign-id', campaignId.value);
    }
    var pageURL = window.location.href;
    var transactionId = CommonUtilFuntions_1.getUrlParameter(pageURL, 'transactionId');
    var statusCode = CommonUtilFuntions_1.getUrlParameter(pageURL, 'statusCode');
    var statusCodeData = CommonUtilFuntions_1.checkStatusCodeFromSession();
    if (transactionId && statusCode) {
        defaultHeaders.append('citi-transaction-id', transactionId);
        defaultHeaders.append('statusCode', statusCode);
    }
    else if ((statusCodeData === null || statusCodeData === void 0 ? void 0 : statusCodeData.statusCode) && (statusCodeData === null || statusCodeData === void 0 ? void 0 : statusCodeData.transactionId)) {
        defaultHeaders.append('citi-transaction-id', statusCodeData === null || statusCodeData === void 0 ? void 0 : statusCodeData.transactionId);
        defaultHeaders.append('statusCode', statusCodeData === null || statusCodeData === void 0 ? void 0 : statusCodeData.statusCode);
    }
    var isGreenRoomEnv = getCookie('IDPGR');
    if (isGreenRoomEnv && isGreenRoomEnv === 'true') {
        defaultHeaders.append('IDPGR', 'true');
    }
    return defaultHeaders;
}
exports.getInitialHeaders = getInitialHeaders;
function amountWithDecimal(priceVal, decimalPointsUpto) {
    var decimalPoints = decimalPointsUpto || 0;
    var amount;
    if (typeof priceVal === 'string') {
        amount = parseFloat(priceVal);
    }
    else {
        amount = priceVal;
    }
    amount = amount.toFixed(decimalPoints);
    return amount;
}
exports.amountWithDecimal = amountWithDecimal;
// tslint:disable-next-line:no-any
function removeArrayElementByIndex(array, index) {
    // tslint:disable-next-line:no-any
    var newArr = [];
    // tslint:disable-next-line:no-any
    array.map(function (key, i) {
        if (index !== i) {
            newArr.push(array[i]);
        }
    });
    return newArr;
}
exports.removeArrayElementByIndex = removeArrayElementByIndex;
function isCheckAvailabilityRequired(serviceAddress) {
    var isAddressIDAvailable = !!(serviceAddress && serviceAddress.addressId);
    return !!((!(serviceAddress && serviceAddress.addressLine1) || isAddressIDAvailable) &&
        (isStandaloneDTVSInCart() || IsSONOSAccessoryInCart()));
}
exports.isCheckAvailabilityRequired = isCheckAvailabilityRequired;
function getCkavStorageData() {
    var ckavContent = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'ckav');
    return __assign(__assign({}, ckavContent), { isPerformed: !!(ckavContent) });
}
exports.getCkavStorageData = getCkavStorageData;
function getCkavCheckoutStorageData() {
    return StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'ckavCheckout');
}
exports.getCkavCheckoutStorageData = getCkavCheckoutStorageData;
function isOrderSubmitted() {
    var orderConfirmationData = StateProvider_1.StateProvider.getStateManagerInstance().
        get(localdatastore_1.getNamespace('CHECKOUT'), 'orderConfirmationData');
    return !!(orderConfirmationData);
}
exports.isOrderSubmitted = isOrderSubmitted;
function getZipCodeForCKAV() {
    var zippyFlow = StateProvider_1.StateProvider.getStateManagerInstance().get(getCurrentLOBNameSpace(), 'zippyFlow');
    return (zippyFlow && zippyFlow.zipCode);
}
exports.getZipCodeForCKAV = getZipCodeForCKAV;
function getBundlesZipCodeForCKAV() {
    var zippyFlow = StateProvider_1.StateProvider.getStateManagerInstance().get('Bundles', 'zippyFlow');
    return (zippyFlow && zippyFlow.zipCode);
}
exports.getBundlesZipCodeForCKAV = getBundlesZipCodeForCKAV;
function getCurrentLOBNameSpace() {
    if (IsDTVSInCart()) {
        return localdatastore_1.getNamespace(CheckoutConstants_1.LOBNames.LOB_DTVS);
    }
    else if (IsBroadbandInCart()) {
        return localdatastore_1.getNamespace(CheckoutConstants_1.LOBNames.LOB_BROADBAND);
    }
    else if (IsIPTVInCart()) {
        return localdatastore_1.getNamespace(CheckoutConstants_1.LOBNames.LOB_IPTV);
    }
    else {
        return localdatastore_1.getNamespace('CHECKOUT');
    }
}
exports.getCurrentLOBNameSpace = getCurrentLOBNameSpace;
// tslint:disable-next-line:no-any
function utilCheckCMSContent(cmsObj, cmskey) {
    if (cmsObj[cmskey] && cmskey) {
        return cmsObj[cmskey];
    }
    else {
        return ' # ' + cmskey + ' CMS key missing #';
    }
}
exports.utilCheckCMSContent = utilCheckCMSContent;
function getLOSGItem(billCode) {
    var temp = getLOSGItems(billCode);
    if (temp && temp.length > 0) {
        return temp[0];
    }
    return null;
}
exports.getLOSGItem = getLOSGItem;
function getLOSGItems(billCode) {
    var _a, _b, _c, _d;
    var payload = getCartResp();
    if (((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs) || ((_b = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _b === void 0 ? void 0 : _b.losgs)) {
        var logsList = ((_c = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _c === void 0 ? void 0 : _c.losgs) || ((_d = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _d === void 0 ? void 0 : _d.losgs);
        var temp = Object.values(logsList).filter(function (losgItem) {
            return Object.values(losgItem.lineItems).filter(function (lineItem) {
                return lineItem.billingCode && lineItem.billingCode === billCode;
            }).length > 0;
        });
        if (temp && temp.length > 0) {
            return temp;
        }
    }
    return null;
}
exports.getLOSGItems = getLOSGItems;
function getLineItem(billCode) {
    var losgItem = getLOSGItem(billCode);
    if (losgItem && losgItem.lineItems && Object.keys(losgItem.lineItems).length > 0) {
        var lineItem = Object.values(losgItem.lineItems).filter(function (lItem) {
            return lItem.billingCode && lItem.billingCode === billCode;
        });
        if (lineItem && lineItem.length > 0) {
            return lineItem[0];
        }
    }
    return null;
}
exports.getLineItem = getLineItem;
function getDisplayName(billCode) {
    var lineItem = getLineItem(billCode);
    if (lineItem) {
        return lineItem.displayName;
    }
    return null;
}
exports.getDisplayName = getDisplayName;
function getLineItemType(billCode) {
    var lineItem = getLineItem(billCode);
    if (lineItem) {
        return lineItem.itemType;
    }
    return null;
}
exports.getLineItemType = getLineItemType;
function getLosgSequence(billCode) {
    var losgItem = getLOSGItems(billCode);
    if (losgItem && losgItem.length > 0) {
        var retVal_1 = new Array();
        losgItem.forEach(function (e) {
            retVal_1.push(e.sequence);
        });
        return retVal_1;
    }
    return null;
}
exports.getLosgSequence = getLosgSequence;
function isAIABFlow() {
    var _a, _b;
    var cartResponse = getCartResp();
    return !!(((_b = (_a = cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.wirelessCart) === null || _a === void 0 ? void 0 : _a.subscriptionClass) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'AI');
}
exports.isAIABFlow = isAIABFlow;
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Monday"] = "monday";
    DayOfWeek["Tuesday"] = "tuesday";
    DayOfWeek["Wednesday"] = "wednesday";
    DayOfWeek["Thursday"] = "thursday";
    DayOfWeek["Friday"] = "friday";
    DayOfWeek["Saturday"] = "saturday";
    DayOfWeek["Sunday"] = "sunday";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
function dateFormatDayMonthDDYYYY(dateval) {
    var weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
        'September', 'October', 'November', 'December'];
    if (dateval) {
        var d = new Date(dateval);
        var year = d.getFullYear();
        var month = months[d.getMonth()];
        var dd = d.getDate();
        var day = weekDays[d.getDay()];
        return day + ", " + month + " " + dd + ", " + year;
    }
    else {
        return dateval;
    }
}
exports.dateFormatDayMonthDDYYYY = dateFormatDayMonthDDYYYY;
function getDay(scheduleDayAndTime) {
    var day = '';
    if (checkDay(scheduleDayAndTime, DayOfWeek.Monday).length > 0) {
        day = checkDay(scheduleDayAndTime, DayOfWeek.Monday);
    }
    else if (checkDay(scheduleDayAndTime, DayOfWeek.Tuesday).length > 0) {
        day = checkDay(scheduleDayAndTime, DayOfWeek.Tuesday);
    }
    else if (checkDay(scheduleDayAndTime, DayOfWeek.Wednesday).length > 0) {
        day = checkDay(scheduleDayAndTime, DayOfWeek.Wednesday);
    }
    else if (checkDay(scheduleDayAndTime, DayOfWeek.Thursday).length > 0) {
        day = checkDay(scheduleDayAndTime, DayOfWeek.Thursday);
    }
    else if (checkDay(scheduleDayAndTime, DayOfWeek.Friday).length > 0) {
        day = checkDay(scheduleDayAndTime, DayOfWeek.Friday);
    }
    else if (checkDay(scheduleDayAndTime, DayOfWeek.Saturday).length > 0) {
        day = checkDay(scheduleDayAndTime, DayOfWeek.Saturday);
    }
    return day;
}
exports.getDay = getDay;
function checkDay(scheduleDayAndTime, day) {
    return scheduleDayAndTime.hasOwnProperty(day) ? day
        : scheduleDayAndTime.hasOwnProperty(day.substring(0, 1).toUpperCase() + day.substring(1))
            ? day.substring(0, 1).toUpperCase() + day.substring(1) : '';
}
exports.checkDay = checkDay;
function isAccessIDEnabledFeatureToggle() {
    var accessIDFeatureToggle = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'accessIDShow');
    return (accessIDFeatureToggle && accessIDFeatureToggle.isDisplay);
}
exports.isAccessIDEnabledFeatureToggle = isAccessIDEnabledFeatureToggle;
function isExistingWirelessCustomerAndHavingBroadbandInCart() {
    return getCustomerState() === 'Authenticated' && IsBroadbandInCart();
}
exports.isExistingWirelessCustomerAndHavingBroadbandInCart = isExistingWirelessCustomerAndHavingBroadbandInCart;
function IsUSTerritoryNeedtoHide() {
    var retVal = false;
    if (getCurrentFlowType() === 'NEW_DTVNOW_NEW_BROADBAND' ||
        getCurrentFlowType() === 'NEW_DTVNOW' ||
        isExistingBBWithDTVN()) {
        retVal = true;
    }
    return retVal;
}
exports.IsUSTerritoryNeedtoHide = IsUSTerritoryNeedtoHide;
function returnOtherValueInNotFound(value, returnValue) {
    return value ? value : returnValue;
}
exports.returnOtherValueInNotFound = returnOtherValueInNotFound;
function creditCardMod10Check(ccNumb) {
    ccNumb = CommonUtilFuntions_1.removeSpecialChars(ccNumb);
    var len = ccNumb.length;
    var iTotal = 0;
    var iCCN;
    if (len >= 15 && ccNumb.includes('X')) {
        return true;
    }
    else if (ccNumb && len >= 15) {
        // tslint:disable-next-line:radix
        iCCN = parseInt(ccNumb);
        for (var i = len; i > 0; i--) {
            // tslint:disable-next-line:radix
            var calc = parseInt('' + iCCN) % 10;
            // tslint:disable-next-line:radix
            calc = parseInt('' + calc);
            iTotal += calc;
            i--;
            iCCN = iCCN / 10;
            // tslint:disable-next-line:radix
            calc = parseInt('' + iCCN) % 10;
            var calc2 = calc * 2;
            switch (calc2) {
                case 10:
                    calc2 = 1;
                    break;
                case 12:
                    calc2 = 3;
                    break;
                case 14:
                    calc2 = 5;
                    break;
                case 16:
                    calc2 = 7;
                    break;
                case 18:
                    calc2 = 9;
                    break;
            }
            iCCN = iCCN / 10;
            iTotal += calc2;
        }
        return ((iTotal % 10) === 0);
    }
    else {
        return false;
    }
}
exports.creditCardMod10Check = creditCardMod10Check;
function getThePaymentMethodDesc(value, flag) {
    if (flag === void 0) { flag = false; }
    var allPaymentMethodTypes = {
        achchecking: 'Checking account',
        achsaving: 'Savings account',
        applepay: 'Apple Pay',
        attgiftcard: 'AT&T Gift Card or promotion card',
        btm: 'Add to my next monthly bill',
        citicard: 'AT&T Points Plus℠ Card',
        creditcard: flag ? 'Credit card' : 'Debit or credit card',
        paypal: 'PayPal',
        debitcard: 'Debit card',
    };
    return allPaymentMethodTypes[value] || value;
}
exports.getThePaymentMethodDesc = getThePaymentMethodDesc;
function isAALFlow() {
    var orderSubType = getOrderSubType();
    var lobList = getLobList();
    return !!(lobList.indexOf(CheckoutConstants_1.LOBNames.LOB_WIRELESS) > -1
        && orderSubType && orderSubType.toUpperCase().indexOf('AAL_WIRELESS') > -1);
}
exports.isAALFlow = isAALFlow;
function isDeviceTradeInApplicable() {
    var payload = getCartResp();
    return !!(payload &&
        payload.metadata && payload.metadata.metadata &&
        payload.metadata.metadata.wirelessMetadata &&
        payload.metadata.metadata.wirelessMetadata.tradeIn);
}
exports.isDeviceTradeInApplicable = isDeviceTradeInApplicable;
function isExistingBBWithDTVN() {
    return getAuthUserState() ? getAuthUserState().broadbandAuthenticated && IsDTVNOWInCart() : false;
}
exports.isExistingBBWithDTVN = isExistingBBWithDTVN;
function getAuthUserState() {
    return StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('Checkout'), 'authStatePayload');
}
exports.getAuthUserState = getAuthUserState;
function getDonartionAmount() {
    var donationAmount = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('Checkout'), 'donationAmount');
    if (donationAmount && donationAmount.amount) {
        return "" + donationAmount.amount;
    }
    return undefined;
}
exports.getDonartionAmount = getDonartionAmount;
function isExistingDTVNWithBB() {
    return getAuthUserState() ? getAuthUserState().dtvnowAuthenticated && IsBroadbandInCart() : false;
}
exports.isExistingDTVNWithBB = isExistingDTVNWithBB;
function isAuthenticatedWirelessFlow() {
    return getCustomerState() === 'Authenticated' && IsWirelessOnlyInCart();
}
exports.isAuthenticatedWirelessFlow = isAuthenticatedWirelessFlow;
function getUpgradeAmount(iType) {
    var payload = getCartResp();
    var retVal = 0;
    if (payload && payload.wirelessCart && payload.wirelessCart.losgs) {
        var logsList = payload.wirelessCart.losgs;
        var losgItems = Object.values(logsList).map(function (losgitem) {
            return Object.values(losgitem === null || losgitem === void 0 ? void 0 : losgitem.lineItems).map(function (lineItem) {
                if (lineItem.itemType && lineItem.itemType.toUpperCase() === iType.toUpperCase()) {
                    if (lineItem.price && lineItem.price.
                        priceType.toUpperCase() === 'DUE_UPON_FFL' &&
                        lineItem.price.baseAmount) {
                        retVal = Number(retVal) + Number(lineItem.price.baseAmount);
                    }
                }
            });
        });
    }
    return retVal;
}
exports.getUpgradeAmount = getUpgradeAmount;
function getMitigationDetails() {
    var mitigationDetails = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'mitigation');
    return mitigationDetails;
}
exports.getMitigationDetails = getMitigationDetails;
function isLoginRequiredonCart() {
    var payload = getCartResp();
    if (payload) {
        return !!payload.requiredLogin;
    }
    return false;
}
exports.isLoginRequiredonCart = isLoginRequiredonCart;
function getauthenticatedPersistantLoginURL(skipCartRedirection) {
    var loginredirectionURL = '/buy/postpaid?wlsfi=';
    var orderSubType = getOrderSubType();
    if (orderSubType) {
        if (orderSubType === 'AAL_WIRELESS') {
            loginredirectionURL = loginredirectionURL + 'AL';
        }
        if (orderSubType === 'UPGRADE_WIRELESS' ||
            orderSubType === 'UP_AL_WIRELESS') {
            loginredirectionURL = loginredirectionURL + 'UP';
        }
    }
    if (!skipCartRedirection) {
        loginredirectionURL = loginredirectionURL + '&redirectTo=CART';
    }
    return loginredirectionURL;
}
exports.getauthenticatedPersistantLoginURL = getauthenticatedPersistantLoginURL;
function getLOSGItemWithSKU(skuId) {
    var payload = getCartResp();
    if (payload &&
        payload.wirelessCart && payload.wirelessCart.losgs) {
        var logsList = payload.wirelessCart.losgs;
        var temp = Object.values(logsList).filter(function (losgItem) {
            return Object.values(losgItem.lineItems).filter(function (lineItem) {
                return lineItem.productSKU && lineItem.productSKU === skuId;
            }).length > 0;
        });
        if (temp.length > 0) {
            return temp[0];
        }
    }
    return null;
}
exports.getLOSGItemWithSKU = getLOSGItemWithSKU;
function getLineItemWithSKU(skuId) {
    var losgItem = getLOSGItemWithSKU(skuId);
    if (losgItem && losgItem.lineItems && Object.keys(losgItem.lineItems).length > 1) {
        var lineItem = Object.values(losgItem.lineItems).filter(function (lItem) {
            return lItem.productSKU && lItem.productSKU === skuId;
        });
        if (lineItem.length > 0) {
            return lineItem[0];
        }
    }
    return null;
}
exports.getLineItemWithSKU = getLineItemWithSKU;
function getCurrentWirelessPlanFromCart() {
    var payload = getCartResp();
    if (payload &&
        payload.wirelessCart && payload.wirelessCart.losgs) {
        var logsList = payload.wirelessCart.losgs;
        var tempLosg = Object.values(logsList).filter(function (losgItem) {
            return Object.values(losgItem.lineItems).filter(function (lineItem) {
                return lineItem.itemType && lineItem.itemType === 'sharedDataGroup';
            }).length > 0;
        });
        if (tempLosg && tempLosg.length > 0 && tempLosg[0].lineItems && Object.keys(tempLosg[0].lineItems).length > 1) {
            var lineItem = Object.values(tempLosg[0].lineItems).filter(function (lItem) {
                return lItem.itemType && lItem.itemType === 'sharedDataGroup';
            });
            if (lineItem.length > 0) {
                return lineItem[0];
            }
        }
    }
    return null;
}
exports.getCurrentWirelessPlanFromCart = getCurrentWirelessPlanFromCart;
function getDisplayNameWithSKU(skuId) {
    var lineItem = getLineItemWithSKU(skuId);
    if (lineItem) {
        return lineItem.displayName;
    }
    return null;
}
exports.getDisplayNameWithSKU = getDisplayNameWithSKU;
function getLosgCount() {
    var payload = getCartResp();
    var losgs = (payload &&
        payload.wirelessCart && payload.wirelessCart.losgs);
    return (losgs ? Object.values(losgs).length : 0);
}
exports.getLosgCount = getLosgCount;
function isIxpFeatureEnabled(feature) {
    var featureToggleStatusData = StateProvider_1.StateProvider.getStateManagerInstance().get(
    // tslint:disable-next-line:no-any
    localdatastore_1.getNamespace('CHECKOUT'), 'featureToggles');
    return !!(featureToggleStatusData && featureToggleStatusData.allocations &&
        featureToggleStatusData.allocations[feature] &&
        featureToggleStatusData.allocations[feature].value === 'true');
}
exports.isIxpFeatureEnabled = isIxpFeatureEnabled;
function getIxpFeatureFlagValue(feature) {
    var featureToggleStatusData = StateProvider_1.StateProvider.getStateManagerInstance().get(
    // tslint:disable-next-line:no-any
    localdatastore_1.getNamespace('CHECKOUT'), 'featureToggles');
    return featureToggleStatusData && featureToggleStatusData.allocations &&
        featureToggleStatusData.allocations[feature] &&
        featureToggleStatusData.allocations[feature].value;
}
exports.getIxpFeatureFlagValue = getIxpFeatureFlagValue;
function isCheckoutIxpFeatureEnabled(feature) {
    var featureToggleStatusData = StateProvider_1.StateProvider.getStateManagerInstance().get(
    // tslint:disable-next-line:no-any
    localdatastore_1.getNamespace('CHECKOUT'), 'featureToggles');
    return !!(featureToggleStatusData && featureToggleStatusData.allocations &&
        featureToggleStatusData.allocations[feature] &&
        featureToggleStatusData.allocations[feature].value === 'true');
}
exports.isCheckoutIxpFeatureEnabled = isCheckoutIxpFeatureEnabled;
function isCartIxpFeatureEnabled(feature) {
    var featureToggleStatusData = StateProvider_1.StateProvider.getStateManagerInstance().get(
    // tslint:disable-next-line:no-any
    localdatastore_1.getNamespace('CART'), 'featureToggles');
    return !!(featureToggleStatusData && featureToggleStatusData.allocations &&
        featureToggleStatusData.allocations[feature] &&
        featureToggleStatusData.allocations[feature].value === 'true');
}
exports.isCartIxpFeatureEnabled = isCartIxpFeatureEnabled;
function getSelectedUpgradeOption() {
    var selectedOption = '';
    var payload = getCartResp();
    if (payload && payload.wirelessCart &&
        payload.wirelessCart.losgs) {
        var selectedUpgradeOptions = Object.values(payload.wirelessCart.losgs).
            filter(function (losg) { return losg.losgType && losg.losgType.toUpperCase() === 'UP' &&
            losg._selectedUpgradeOption; });
        if (selectedUpgradeOptions && selectedUpgradeOptions.length > 0) {
            selectedOption = selectedUpgradeOptions[0]._selectedUpgradeOption;
        }
    }
    return selectedOption;
}
exports.getSelectedUpgradeOption = getSelectedUpgradeOption;
function formmatedMultiAddressArray(listOfAddress) {
    var filteredAdrsList = [];
    listOfAddress.forEach(function (address) {
        var adrsMatchcode = address.locationDetail.addressMatchCode;
        if (adrsMatchcode.startsWith('4')) {
            filteredAdrsList.push(address);
        }
    });
    return (filteredAdrsList.length > 5) ? filteredAdrsList.slice(0, 5) : filteredAdrsList;
}
exports.formmatedMultiAddressArray = formmatedMultiAddressArray;
function getPriceDataForPrepaidFlow(payload, priceBarData) {
    var stickyCartFeatureFlag;
    if (payload && payload.enableStickyCartCharges) {
        stickyCartFeatureFlag = payload.enableStickyCartCharges;
        // Double equals is added intentionally. Do not change.
        if (stickyCartFeatureFlag && priceBarData && Number(priceBarData.dueMonthly) === 0) {
            delete priceBarData.dueMonthly;
        }
        if (stickyCartFeatureFlag && priceBarData && Number(priceBarData.dueOneTime) === 0) {
            delete priceBarData.dueOneTime;
        }
    }
    return priceBarData;
}
exports.getPriceDataForPrepaidFlow = getPriceDataForPrepaidFlow;
function getPriceBarData(payload) {
    var priceBarUpdate;
    if (isPrepaidFlowType()) {
        var cartState = getPriceDataForPrepaidFlow(payload, payload.orderPriceInfo);
        priceBarUpdate = {
            dueMonthly: cartState.dueMonthly,
            dueOneTime: cartState.dueOneTime,
            dueToday: cartState.dueToday,
            isAmtProvidedTaxInclusive: cartState.taxCalculated,
            readyToCheckout: payload.cartStatus.readyToCheckout,
        };
    }
    else {
        var cartStatus = getCartStatus();
        priceBarUpdate = {
            dueMonthly: payload.orderPriceInfo.dueMonthly,
            dueOneTime: payload.orderPriceInfo.dueOneTime,
            dueToday: payload.orderPriceInfo.dueToday,
            isAmtProvidedTaxInclusive: payload.orderPriceInfo.taxCalculated,
            readyToCheckout: cartStatus.readyToCheckout,
        };
    }
    return priceBarUpdate;
}
exports.getPriceBarData = getPriceBarData;
function formatCreditInformationResponse(data) {
    if (data && data.content) {
        var creditInfoStatus = !!(data.content.creditInfo && data.content.creditInfo.status);
        checkCreditCheckStatusAndRedirect(data);
        var creditData = {
            creditCheckResponse: creditInfoStatus ?
                data : undefined,
            dateOfBirth: '',
            reRunCreditCheckStatus: creditInfoStatus ?
                data.content.creditInfo.status : '',
            socialSecurity: '',
        };
        var suppressPanelDisplay = data.content.internalCreditCheckTriggered;
        var eligibleIdentityOptions = data.content.eligibleIdentityOptions;
        return { creditData: creditData, eligibleIdentityOptions: eligibleIdentityOptions, suppressPanelDisplay: suppressPanelDisplay };
    }
    else {
        return undefined;
    }
}
exports.formatCreditInformationResponse = formatCreditInformationResponse;
function checkCreditCheckStatusAndRedirect(creditResponse) {
    var _a, _b, _c, _d, _e;
    var hardStopResponse = null;
    switch ((_c = (_b = (_a = creditResponse === null || creditResponse === void 0 ? void 0 : creditResponse.content) === null || _a === void 0 ? void 0 : _a.creditInfo) === null || _b === void 0 ? void 0 : _b.status) === null || _c === void 0 ? void 0 : _c.toUpperCase()) {
        case 'FAILURE': {
            var cmsData = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'cartcheckout').content.
                creditVerificationPanel.panelContent;
            hardStopResponse = handleCreditRespError((_e = (_d = creditResponse === null || creditResponse === void 0 ? void 0 : creditResponse.content) === null || _d === void 0 ? void 0 : _d.creditInfo) === null || _e === void 0 ? void 0 : _e.error, cmsData);
            break;
        }
        case 'DEPOSIT_HARDSTOP': {
            var cmsData = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'cartcheckout').content.creditVerificationPanel.panelContent;
            hardStopResponse = {
                data: JSON.stringify({ trace: creditResponse }),
                hardStopTitle: 'Unable to complete order online',
                hardStopperText: ((isSMBNewBBCustomerFlow()) ?
                    CommonUtilFuntions_1.getHardStopText(cmsData === null || cmsData === void 0 ? void 0 : cmsData.smbWirelineBBHardStopText) :
                    CommonUtilFuntions_1.getHardStopText(cmsData === null || cmsData === void 0 ? void 0 : cmsData.smbDebtHardStop, cmsData)),
                reasonCode: 'DEPOSIT_HARDSTOP',
            };
            break;
        }
        case 'DEBT_HARDSTOP': {
            var cmsData = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'cartcheckout').content.
                creditVerificationPanel.panelContent;
            hardStopResponse = {
                data: JSON.stringify({ trace: creditResponse }),
                hardStopTitle: 'Unable to complete order online',
                hardStopperText: getHardStopperText(cmsData, CommonUtilFuntions_1.getHardStopText(cmsData === null || cmsData === void 0 ? void 0 : cmsData.outstandingBalanceErrTxt)),
                reasonCode: 'DEBT_HARDSTOP',
            };
            break;
        }
        case 'EIDFAILED': {
            var cmsData = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'cartcheckout').content.
                creditVerificationPanel.panelContent;
            var scCmsData = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'cartcheckout').content.creditVerificationPanel.creditSafeScan;
            hardStopResponse = {
                data: JSON.stringify({ trace: creditResponse }),
                hardStopPrimaryBtnLabel: scCmsData.creditSafeHardStopSecondaryBtnLabel,
                hardStopScondaryBtnLabel: scCmsData.creditSafeHardStopPrimaryBtnLabel,
                hardStopTitle: scCmsData.creditSafeScanHardStopErrorLabel,
                hardStopperText: getHardStopperText(cmsData, CommonUtilFuntions_1.getHardStopText(scCmsData === null || scCmsData === void 0 ? void 0 : scCmsData.creditSafeScanHardStopErrorTxt)),
                reasonCode: 'EIDFAILED',
            };
            break;
        }
        case 'ATTTV_MEDIUM_RISK_HARDSTOP': {
            var cmsData = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'cartcheckout').content.
                creditVerificationPanel.panelContent;
            hardStopResponse = {
                data: JSON.stringify({ trace: creditResponse }),
                hardStopTitle: 'Unable to complete order online',
                hardStopperText: getHardStopperText(cmsData, CommonUtilFuntions_1.getHardStopText(cmsData === null || cmsData === void 0 ? void 0 : cmsData.creditMidRiskHelpLabel)),
                reasonCode: 'ATTTV_MEDIUM_RISK_HARDSTOP',
            };
            break;
        }
    }
    if (hardStopResponse) {
        StateProvider_1.StateProvider.getStateManagerInstance().set('hardStop', hardStopResponse);
        return hardStopResponse;
    }
    return null;
}
exports.checkCreditCheckStatusAndRedirect = checkCreditCheckStatusAndRedirect;
function handleCreditRespError(error, cmsData) {
    var isSMBAALFlow = isValidSMBCustomer() && isAALFlow();
    var hardstopText = CommonUtilFuntions_1.getHardStopText(cmsData === null || cmsData === void 0 ? void 0 : cmsData.smbDebtHardStop);
    switch (error === null || error === void 0 ? void 0 : error.errorId) {
        case 'CreditCheck-1011':
        case 'CreditCheck-1013':
        case 'CreditCheck-1014':
        case 'CreditCheck-1015':
        case 'CreditInfo-Api-Call-Failure':
        case 'CreditCheck-1030':
        case 'CreditCheck-1016': {
            return {
                data: JSON.stringify({ trace: error }),
                hardStopperText: isSMBAALFlow ? hardstopText : getResponseErrorHardStopperText(cmsData, CommonUtilFuntions_1.getHardStopText(cmsData === null || cmsData === void 0 ? void 0 : cmsData.callUsHelpLabel)),
                reasonCode: error.errorId,
            };
        }
        case 'CreditCheck-1006':
        case 'CreditCheck-Debt-Error': {
            return {
                data: JSON.stringify({ trace: error }),
                hardStopTitle: 'Unable to complete order online',
                hardStopperText: isSMBAALFlow ? hardstopText : getResponseErrorHardStopperText(cmsData, CommonUtilFuntions_1.getHardStopText(cmsData === null || cmsData === void 0 ? void 0 : cmsData.outstandingBalanceErrTxt)),
                reasonCode: error.errorId,
            };
        }
        case 'CreditCheck-4000': {
            return {
                data: JSON.stringify({ trace: error }),
                hardStopTitle: 'Unable to complete order online',
                hardStopperText: isSMBAALFlow ? hardstopText :
                    getResponseErrorHardStopperText(cmsData, (cmsData.hardStop4000ErrorMessageLabel.replace('[callUsHelpLabel]', CommonUtilFuntions_1.getHardStopText(cmsData === null || cmsData === void 0 ? void 0 : cmsData.callUsHelpLabel)))),
                reasonCode: error.errorId,
            };
        }
        case 'CreditCheck-1020': {
            var checkoutCMS = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'CheckoutCms').content.consoleContent;
            return {
                data: JSON.stringify({ trace: error }),
                hardStopperText: isSMBAALFlow ? hardstopText : getResponseErrorHardStopperText(cmsData, checkoutCMS.hardStopRetailStoreLabel),
                reasonCode: error.errorId,
            };
        }
    }
}
exports.handleCreditRespError = handleCreditRespError;
function getResponseErrorHardStopperText(cmsData, defaultContent) {
    var isNewSMBWirelineFlow = isSMBBBCustomerFlow();
    if (isNewSMBWirelineFlow) {
        return CommonUtilFuntions_1.getHardStopText(cmsData === null || cmsData === void 0 ? void 0 : cmsData.smbWirelineBBHardStopText);
    }
    else {
        return defaultContent;
    }
}
exports.getResponseErrorHardStopperText = getResponseErrorHardStopperText;
function getHardStopperText(cmsData, defaultContent) {
    var isSMBCustomerAALFlow = isValidSMBCustomer() && isAALFlow();
    var isNewSMBWirelineFlow = isSMBBBCustomerFlow();
    if (isSMBCustomerAALFlow) {
        return CommonUtilFuntions_1.getHardStopText(cmsData === null || cmsData === void 0 ? void 0 : cmsData.smbDebtHardStop);
    }
    else if (isNewSMBWirelineFlow) {
        return CommonUtilFuntions_1.getHardStopText(cmsData === null || cmsData === void 0 ? void 0 : cmsData.smbWirelineBBHardStopText);
    }
    else {
        return defaultContent;
    }
}
exports.getHardStopperText = getHardStopperText;
function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    var cookieName = '';
    ca.forEach(function (val) {
        var c = val;
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            cookieName = c.substring(name.length, c.length);
        }
    });
    return cookieName;
}
exports.getCookie = getCookie;
function getMigrationSource() {
    var payload = getCartResp();
    var migrationSource = '';
    if (payload && payload.metadata &&
        payload.metadata.metadata && payload.metadata.metadata.iptvMetadata &&
        payload.metadata.metadata.iptvMetadata.losgs) {
        var iptvMetadataLog_1 = Object.values(payload.metadata.metadata.iptvMetadata.losgs);
        iptvMetadataLog_1.forEach(function (item, index) {
            if (iptvMetadataLog_1[index] && iptvMetadataLog_1[index].migrationSource) {
                migrationSource = iptvMetadataLog_1[index].migrationSource;
            }
        });
    }
    return migrationSource;
}
exports.getMigrationSource = getMigrationSource;
function isIOS() {
    return /iPhone|iPod|iPad/.test(navigator.userAgent) ||
        (navigator.userAgent.includes('Macintosh') && navigator.maxTouchPoints > 1); // for iOS 13
}
exports.isIOS = isIOS;
function isMyATTApp() {
    var cookieVal = getCookie('accessDomain');
    if (cookieVal && cookieVal.toLowerCase() === 'native') {
        return true;
    }
    else {
        return false;
    }
    /* old code CDEX-257681
    // tslint:disable-next-line:no-any
    const webkit: any = window.webkit;
    const isMyAttApp = (typeof webkit !== 'undefined' && webkit != null) &&
      (typeof webkit.messageHandlers !== 'undefined' && webkit.messageHandlers != null);
    return isMyAttApp;
    */
}
exports.isMyATTApp = isMyATTApp;
function isNotWlsWithUPGOrAALFlow() {
    var currentFLowType = getCurrentFlowType();
    var paymentStatus = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'isPaymentSuccessful');
    return !((currentFLowType === CheckoutConstants_1.FlowType.AAL_WIRELESS ||
        currentFLowType === CheckoutConstants_1.FlowType.UPGRADE_WIRELESS || currentFLowType ===
        CheckoutConstants_1.FlowType.UP_AL_WIRELESS) && !(paymentStatus && paymentStatus.isPaymentSuccessful));
}
exports.isNotWlsWithUPGOrAALFlow = isNotWlsWithUPGOrAALFlow;
function neustarApiCall() {
    var sessionID = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('APPSHELL'), 'sid');
    var neustarEncryptedKey = getIxpFeatureFlagValue('cfg-neustar-on-checkout') || '';
    if (window && typeof window._nsr_handshake === 'function') {
        window._nsr_handshake(sessionID && sessionID.value, neustarEncryptedKey, 'https://nifegwy.neustar.biz/v2/access/query');
    }
}
exports.neustarApiCall = neustarApiCall;
function isExpressUpgradeViewEnabled() {
    var payload = getCartResp();
    return (payload && payload.enableExpupgradeView);
}
exports.isExpressUpgradeViewEnabled = isExpressUpgradeViewEnabled;
function IsEmployeeOfferAvailable() {
    var payload = getCartResp();
    return !!(IsStandaloneDTVNOWInCart() && payload
        && payload.dtvnowCart && payload.dtvnowCart.businessType
        && payload.dtvnowCart.businessType.toUpperCase() === 'EMPLOYEE');
}
exports.IsEmployeeOfferAvailable = IsEmployeeOfferAvailable;
function isValidSMBCustomer() {
    var isSmbNonContracted = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'isSmbCustomer');
    var payload = getCartResp();
    var isEnterPriseTypeCRU = payload &&
        ((payload.b2bDetail && payload.b2bDetail._enterpriseType &&
            payload.b2bDetail._enterpriseType === 'CRU') ||
            (payload.wirelessCart && payload.wirelessCart._orderExtraAttributes &&
                payload.wirelessCart._orderExtraAttributes._isSMBCustomer &&
                payload.wirelessCart._orderExtraAttributes._isSMBCustomer === 'true') ||
            (payload.broadbandCart &&
                payload.broadbandCart.customerType &&
                payload.broadbandCart.customerType.toUpperCase() === 'SMB') ||
            (payload.businessAppCart &&
                payload.businessAppCart.customerType &&
                payload.businessAppCart.customerType.toUpperCase() === 'SMB'));
    if (!!isEnterPriseTypeCRU || !!(isSmbNonContracted && isSmbNonContracted.isNonContracted)) {
        return true;
    }
    return false;
}
exports.isValidSMBCustomer = isValidSMBCustomer;
function isSMBNewCustomerFlow() {
    if (!!isValidSMBCustomer() && !!(getCustomerState() !== 'Authenticated' &&
        (IsWirelessInCart()))) {
        return true;
    }
    return false;
}
exports.isSMBNewCustomerFlow = isSMBNewCustomerFlow;
function isSMBNEWAiaBCustomerFlow() {
    var _a, _b;
    var cartResp = getCartResp();
    var aiaBusiness = !!(((_b = (_a = cartResp === null || cartResp === void 0 ? void 0 : cartResp.wirelessCart) === null || _a === void 0 ? void 0 : _a.subscriptionClass) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'AI');
    if (!!isValidSMBCustomer() && !!(getCustomerState() !== 'Authenticated' &&
        (IsWirelessInCart()) && aiaBusiness)) {
        return true;
    }
    return false;
}
exports.isSMBNEWAiaBCustomerFlow = isSMBNEWAiaBCustomerFlow;
function isSMBNewBBCustomerFlow() {
    if (!!isValidSMBCustomer() &&
        !!((IsBroadbandInCart() || IsStandaloneBusinessToolsInCart()))) {
        return true;
    }
    return false;
}
exports.isSMBNewBBCustomerFlow = isSMBNewBBCustomerFlow;
function isBusinessAppsFlow() {
    var payload = getCartResp();
    return !!(isThisLOBInMetaData(CheckoutConstants_1.LOBNames.LOB_BUSINESSAPPS)
        && payload.businessAppCart);
}
exports.isBusinessAppsFlow = isBusinessAppsFlow;
function isSMBBBCustomerFlow() {
    var payload = getCartResp();
    if (!!isValidSMBCustomer() && (payload === null || payload === void 0 ? void 0 : payload.broadbandCart)) {
        return true;
    }
    else if (!!isValidSMBCustomer() && (payload === null || payload === void 0 ? void 0 : payload.businessAppCart)) {
        return true;
    }
    return false;
}
exports.isSMBBBCustomerFlow = isSMBBBCustomerFlow;
function isValidEDSPFlow() {
    var _a;
    var payload = getCartResp();
    return (((_a = payload === null || payload === void 0 ? void 0 : payload.dtvnowCart) === null || _a === void 0 ? void 0 : _a.contractType) === 'EDSP');
}
exports.isValidEDSPFlow = isValidEDSPFlow;
function isUPOrAALFlow() {
    var currentFlowType = getCurrentFlowType();
    return ((currentFlowType === null || currentFlowType === void 0 ? void 0 : currentFlowType.indexOf(CheckoutConstants_1.FlowType.UPGRADE_WIRELESS)) > -1 ||
        (currentFlowType === null || currentFlowType === void 0 ? void 0 : currentFlowType.indexOf(CheckoutConstants_1.FlowType.UP_AL_WIRELESS)) > -1 ||
        (currentFlowType === null || currentFlowType === void 0 ? void 0 : currentFlowType.indexOf(CheckoutConstants_1.FlowType.AAL_WIRELESS)) > -1);
}
exports.isUPOrAALFlow = isUPOrAALFlow;
function getLOSGItemsforWireline() {
    var payload = getCartResp();
    if (payload && payload.dtvnowCart && payload.dtvnowCart.losgs) {
        var logsList = payload.dtvnowCart.losgs;
        var temp = Object.values(logsList).filter(function (losgItem) {
            return Object.values(losgItem.lineItems).filter(function (lineItem) {
                return lineItem.billingCode;
            }).length > 0;
        });
        if (temp && temp.length > 0) {
            return temp;
        }
    }
    return null;
}
exports.getLOSGItemsforWireline = getLOSGItemsforWireline;
function isAutoPayPaymentMerged() {
    var shouldAutoPayPaymentMerge = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'isAutoPayPayMergeWithPayment');
    return (shouldAutoPayPaymentMerge === null || shouldAutoPayPaymentMerge === void 0 ? void 0 : shouldAutoPayPaymentMerge.isAutoPayPayMergeWithPayment);
}
exports.isAutoPayPaymentMerged = isAutoPayPaymentMerged;
function getSmartyStreetKey() {
    var hostname = window && window.location && window.location.hostname;
    return hostname === 'localhost' ? '7895321499068899' : '2021202165494638221';
}
exports.getSmartyStreetKey = getSmartyStreetKey;
function isStandaloneBroadbandInCart() {
    var retVal = false;
    var payload = getCartResp();
    var lobList = getLobList();
    if (lobList && lobList.length === 1 && lobList.indexOf('BROADBAND') !== -1 && payload.broadbandCart) {
        retVal = true;
    }
    return retVal;
}
exports.isStandaloneBroadbandInCart = isStandaloneBroadbandInCart;
function applyRewardCardPromo(losgId) {
    var payload = getCartResp();
    var rewardCardApplies = false;
    if (losgId && payload && payload.wirelessCart && payload.wirelessCart.losgs) {
        var losgObject = Object.values(payload.wirelessCart.losgs).
            filter(function (losg) { return losg.id && losg.id === losgId; });
        if (losgObject && losgObject.length > 0 && losgObject[0].portInRewardPromotionAvailable) {
            rewardCardApplies = true;
        }
    }
    return rewardCardApplies;
}
exports.applyRewardCardPromo = applyRewardCardPromo;
function rewardCardAvailable() {
    var payload = getCartResp();
    if (payload && payload.wirelessCart && payload.wirelessCart.losgs) {
        var losgs_1 = Object.values(payload.wirelessCart.losgs);
        losgs_1.forEach(function (losg, index) {
            if (losgs_1[index] && losgs_1[index].portInRewardPromotionAvailable) {
                return losgs_1[index].portInRewardPromotionAvailable;
            }
        });
    }
    return false;
}
exports.rewardCardAvailable = rewardCardAvailable;
function cartHasBroadbandABPDiscount() {
    var _a, _b;
    var payload = getCartResp();
    if ((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.broadbandCart) === null || _a === void 0 ? void 0 : _a.promotions) === null || _b === void 0 ? void 0 : _b.length) {
        return payload.broadbandCart.promotions.some(function (promo) { return promo.promotionCategory === 'ABPDiscount'; });
    }
    return false;
}
exports.cartHasBroadbandABPDiscount = cartHasBroadbandABPDiscount;
var GET_ICON_URL;
(function (GET_ICON_URL) {
    GET_ICON_URL["PEN"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><path fill=\"#000000\" d=\"M23.1 8.2l5.6 5.6-13.3 13.3s-.1 0-.1.1c-.3.3-.7.5-1 .7l-7.7 3.2c-.4.2-.9-.3-.7-.7l3.2-7.7c.1-.3.4-.7.6-1l.1-.1L23.1 8.2zm8.1-.8l-1.7-1.7c-1.1-1.1-2.8-1.1-3.8-.1l-1.5 1.5 5.6 5.6 1.5-1.5c1-1 .9-2.7-.1-3.8z\"/></svg>";
    GET_ICON_URL["CHECK"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M11.33 26.75l-10-10 1.42-1.42 8.62 8.63 18-18 1.42 1.41z\"/></svg>";
    GET_ICON_URL["QUESTION"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"svg-base\" d=\"M8.5 1A7.5 7.5 0 1016 8.5 7.5 7.5 0 008.5 1zM9 12H8v-1h1zm.83-3.55l-.1.08C9.16 9 9 9.13 9 9.68V10H8v-.32a2.21 2.21 0 011.1-1.93l.11-.08a1.11 1.11 0 00.54-.9c0-.69-.72-.76-1-.76a2.18 2.18 0 00-1.45.63l-.7-.74A3.14 3.14 0 018.72 5a1.8 1.8 0 012 1.76 2.11 2.11 0 01-.89 1.69z\"/></svg>";
    GET_ICON_URL["E_SIM"] = "<svg data-name=\"Icon (Outlined)\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"><path class=\"svg-base\" d=\"M76.38 24.87l-12.17-13A6 6 0 0059.83 10H24a6 6 0 00-6 6v64a6 6 0 006 6h48a6 6 0 006-6V29a6 6 0 00-1.62-4.13zM76 80a4 4 0 01-4 4H24a4 4 0 01-4-4V16a4 4 0 014-4h35.83a4 4 0 012.92 1.26l12.17 13A4 4 0 0176 29z\"/><path class=\"svg-accent\" d=\"M54 50H28v28h40V50zM40 76H30V63h10zm12 0H42V61H30v-9h22zm14 0H54v-8h12zm0-10H54V52h12zm-7.17-36.45a13.5 13.5 0 00-1.26-5.92A9.84 9.84 0 0054 19.51a10 10 0 00-5.5-1.5 10.38 10.38 0 00-5.62 1.6 11.42 11.42 0 00-4.12 4.58A14.48 14.48 0 0037.17 31a14.7 14.7 0 001.47 6.67 11.3 11.3 0 004.25 4.63 12.14 12.14 0 006.49 1.7 18.29 18.29 0 004.73-.55 15.15 15.15 0 004-1.82l-.88-1.84a15.51 15.51 0 01-3.68 1.57 16.59 16.59 0 01-4.22.46 9.55 9.55 0 01-4.82-1.23A9.3 9.3 0 0141.09 37a11.78 11.78 0 01-1.45-5.36h19.1q.09-1.02.09-2.09zm-2.47.09H39.69a12.51 12.51 0 011.4-4.82 9 9 0 013.08-3.39 8.14 8.14 0 018.39-.15 7.33 7.33 0 012.78 3.23 10.85 10.85 0 011 4.75z\"/></svg>";
    GET_ICON_URL["P_SIM"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"><path class=\"svg-base\" d=\"M72 86H24a6 6 0 01-6-6V16a6 6 0 016-6h35.83a6 6 0 014.38 1.9l12.17 13A6 6 0 0178 29v51a6 6 0 01-6 6zM24 12a4 4 0 00-4 4v64a4 4 0 004 4h48a4 4 0 004-4V29a4 4 0 00-1.08-2.74l-12.17-13A4 4 0 0059.83 12z\"/><path class=\"svg-accent\" d=\"M28 48v29h40V48zm38 17H54V50h12zM52 50v25H42V60H30V50zM30 62h10v13H30zm24 13v-8h12v8z\"/></svg>";
    GET_ICON_URL["INFO"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><path fill=\"#0057B8\" d=\"M18 3C9.7 3 3 9.7 3 18s6.7 15 15 15 15-6.7 15-15S26.3 3 18 3zm1.4 23.8h-2.6V14.4h2.6v12.4zm-.2-14.9c-.3.3-.7.4-1.1.4-.5 0-.9-.1-1.1-.4-.3-.3-.4-.6-.4-1.1 0-.4.1-.8.4-1.1.3-.3.7-.4 1.1-.4.5 0 .8.1 1.1.4.3.3.4.6.4 1.1.1.5-.1.8-.4 1.1z\"/></svg>";
})(GET_ICON_URL = exports.GET_ICON_URL || (exports.GET_ICON_URL = {}));
var SVG_ICONS;
(function (SVG_ICONS) {
    SVG_ICONS["VOICE"] = "<svg aria-hidden=\"true\" class=\"inline-block svg-accent-att-blue color-black\" focusable=\"false\" height=\"96px\" width=\"96px\" viewBox=\"0 0 96 96\"><path class=\"svg-accent\" d=\"M45 51h30V37H45zm2-12h26v10H47z\"></path><path class=\"svg-base\" d=\"M80 27H36v-7a6 6 0 00-6-6H16a6 6 0 00-6 6v56a6 6 0 006 6h64a6 6 0 006-6V33a6 6 0 00-6-6zM34 80H16a4 4 0 01-4-4V20a4 4 0 014-4h14a4 4 0 014 4v60zm50-4a4 4 0 01-4 4H36V29h44a4 4 0 014 4zM45 56h6v2h-6zm12 0h6v2h-6zm12 0h6v2h-6zm-24 7h6v2h-6zm12 0h6v2h-6zm12 0h6v2h-6zm-24 7h6v2h-6zm12 0h6v2h-6zm12 0h6v2h-6z\"></path></svg>";
})(SVG_ICONS = exports.SVG_ICONS || (exports.SVG_ICONS = {}));
function isSMBNewBBSelected() {
    var SMBFulfillMethod = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'SMBFulfillMethod');
    return !!(SMBFulfillMethod && SMBFulfillMethod.isSelected);
}
exports.isSMBNewBBSelected = isSMBNewBBSelected;
function isSMBNewStandaloneBroadbandFlow() {
    if (!!(isSMBNewBBCustomerFlow() && isStandaloneBroadbandInCart())) {
        return true;
    }
    return false;
}
exports.isSMBNewStandaloneBroadbandFlow = isSMBNewStandaloneBroadbandFlow;
exports.isPaymentExpressView = function () {
    var _a, _b, _c;
    var payload = getCartResp();
    return !!(((_c = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.orderSource) === null || _c === void 0 ? void 0 : _c.includes('SMART')) ||
        (getCurrentFlowType() === CheckoutConstants_1.FlowType.AAL_WIRELESS_ACTIVATION));
};
exports.isConnectedCarFlow = function () {
    var _a, _b, _c;
    var payload = getCartResp();
    return !!((_c = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.orderSource) === null || _c === void 0 ? void 0 : _c.includes('SMART'));
};
function isHylaItemAvail() {
    var isHyla = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'hasHylaItems');
    return !!(isHyla && isHyla.hasHylaItems);
}
exports.isHylaItemAvail = isHylaItemAvail;
function isBusinessTypeReconnect() {
    var _a, _b, _c, _d;
    var losgs = getLOSGItemsforWireline();
    if ((losgs === null || losgs === void 0 ? void 0 : losgs.length) > 0 && ((_a = losgs[0]) === null || _a === void 0 ? void 0 : _a.lineItems)) {
        var lineItems = Object.values((_b = losgs[0]) === null || _b === void 0 ? void 0 : _b.lineItems);
        return !!(((_c = lineItems[0]) === null || _c === void 0 ? void 0 : _c._offerType) && ((_d = lineItems[0]) === null || _d === void 0 ? void 0 : _d._offerType) === 'reconnect');
    }
    return false;
}
exports.isBusinessTypeReconnect = isBusinessTypeReconnect;
function checkBusinessType(offerType) {
    var losgs = getLOSGItemsforWireline();
    var isOfferMatched = false;
    if (losgs) {
        var losgValues = Object.values(losgs);
        losgValues === null || losgValues === void 0 ? void 0 : losgValues.find(function (val) {
            var lineItems = Object.values(val && val.lineItems);
            if (lineItems) {
                lineItems.find(function (item) {
                    if (item && item._offerType && item._offerType.toUpperCase() === offerType.toUpperCase()) {
                        isOfferMatched = !isOfferMatched;
                    }
                    return isOfferMatched;
                });
            }
            return isOfferMatched;
        });
    }
    return isOfferMatched;
}
exports.checkBusinessType = checkBusinessType;
function isWireLineBrePromo() {
    var _a;
    var payload = getCartResp();
    return ((_a = payload === null || payload === void 0 ? void 0 : payload.dtvnowCart) === null || _a === void 0 ? void 0 : _a.brePromo);
}
exports.isWireLineBrePromo = isWireLineBrePromo;
function isBsseAccessoryFlow() {
    var accessoryFlows = StateProvider_1.StateProvider.getStateManagerInstance().get('CHECKOUT', 'accessoryFlows');
    return (accessoryFlows && accessoryFlows.isBsseAccessoryFlow);
}
exports.isBsseAccessoryFlow = isBsseAccessoryFlow;
function isAccessoryEligibleFlow() {
    var accessoryFlows = StateProvider_1.StateProvider.getStateManagerInstance().get('CHECKOUT', 'accessoryFlows');
    if (accessoryFlows && accessoryFlows.isAccessoryOnlyFlow) {
        return accessoryFlows.isAccessoryOnlyFlow;
    }
    else if (accessoryFlows && accessoryFlows.isBsseAccessoryFlow) {
        return accessoryFlows.isBsseAccessoryFlow;
    }
    else {
        return false;
    }
}
exports.isAccessoryEligibleFlow = isAccessoryEligibleFlow;
function getSubFlowTypeForHeaders() {
    if (isSMBNewCustomerFlow()) {
        return 'NEW_SMB';
    }
    else if (isAccessoryOnlyInCart()) {
        return 'ACCESSORIES_ONLY';
    }
    return '';
}
exports.getSubFlowTypeForHeaders = getSubFlowTypeForHeaders;
function isAccessoryOnlyInCart() {
    var _a, _b, _c;
    var isNonAccessoryInCart = false;
    var isAccessoryInCart = false;
    var payload = getCartResp();
    var losgs = ((_c = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.wirelessMetadata) === null || _c === void 0 ? void 0 : _c.losgs);
    var losgList = losgs && Object.values(losgs);
    if ((losgList === null || losgList === void 0 ? void 0 : losgList.length) > 0) {
        losgList.forEach(function (losg) {
            if ((losg === null || losg === void 0 ? void 0 : losg.losgType) === 'ACC') {
                isAccessoryInCart = true;
            }
            else {
                isNonAccessoryInCart = true;
            }
        });
    }
    if (isAccessoryInCart && !isNonAccessoryInCart) {
        return true;
    }
    return false;
}
exports.isAccessoryOnlyInCart = isAccessoryOnlyInCart;
function isFirstNetFlow() {
    var _a;
    var payload = getCartResp();
    var isfirstNet = false;
    if ((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        Object.values(payload.wirelessCart.losgs).forEach(function (losg) {
            if ((losg === null || losg === void 0 ? void 0 : losg._fnIntendInd) || (losg === null || losg === void 0 ? void 0 : losg.fnUserId)) {
                isfirstNet = true;
            }
        });
    }
    return isfirstNet;
}
exports.isFirstNetFlow = isFirstNetFlow;
function IsWirelessFirstNetFlow() {
    if (isFirstNetFlow() && IsWirelessInCart()) {
        return true;
    }
    return false;
}
exports.IsWirelessFirstNetFlow = IsWirelessFirstNetFlow;
function isFirstNetCaribbean() {
    var _a;
    var payload = getCartResp();
    var isfirstNetCaribbean = false;
    if ((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        Object.values(payload.wirelessCart.losgs).forEach(function (losg) {
            var _a;
            if ((losg === null || losg === void 0 ? void 0 : losg._fnCaribbean) || ((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a._fnCaribbeanOrder)) {
                isfirstNetCaribbean = true;
            }
        });
    }
    return isfirstNetCaribbean;
}
exports.isFirstNetCaribbean = isFirstNetCaribbean;
function isFirstNetFlowForLosgId(losgId) {
    var _a;
    var payload = getCartResp();
    var isfirstNet = false;
    if (losgId && ((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs)) {
        var losgObject = Object.values(payload.wirelessCart.losgs).
            filter(function (losg) { return losg.id && losg.id === losgId; });
        if (losgObject && losgObject.length > 0 && losgObject[0]._fnIntendInd) {
            isfirstNet = true;
        }
    }
    return isfirstNet;
}
exports.isFirstNetFlowForLosgId = isFirstNetFlowForLosgId;
function isBSSEShippingAddrHasError() {
    var shippingInfo = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'shippingAddrValidationError');
    return !!(IsBsseFlow() && IsWirelessInCart() && (shippingInfo === null || shippingInfo === void 0 ? void 0 : shippingInfo.shippingError));
}
exports.isBSSEShippingAddrHasError = isBSSEShippingAddrHasError;
function isUPFlow() {
    var currentFlowType = getCurrentFlowType();
    return ((currentFlowType === null || currentFlowType === void 0 ? void 0 : currentFlowType.indexOf(CheckoutConstants_1.FlowType.UPGRADE_WIRELESS)) > -1 ||
        (currentFlowType === null || currentFlowType === void 0 ? void 0 : currentFlowType.indexOf(CheckoutConstants_1.FlowType.UP_AL_WIRELESS)) > -1);
}
exports.isUPFlow = isUPFlow;
function isHOGMessageInCart() {
    var hogMessage = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'isHoldOutGroupMessage');
    return (hogMessage && hogMessage.isHoldOutGroupMessage);
}
exports.isHOGMessageInCart = isHOGMessageInCart;
function isNewWLSCustomerFlow() {
    if (!!(getCustomerState() !== 'Authenticated' && IsWirelessInCart())) {
        return true;
    }
    return false;
}
exports.isNewWLSCustomerFlow = isNewWLSCustomerFlow;
function showOnDeviceWearablePPU() {
    var ppuPanel = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'showOnDeviceWearablePPU');
    return !!(ppuPanel && ppuPanel.showPanel);
}
exports.showOnDeviceWearablePPU = showOnDeviceWearablePPU;
function isAppleDevice() {
    var _a;
    var isApple = false;
    var cartResp = getCartResp();
    if ((_a = cartResp === null || cartResp === void 0 ? void 0 : cartResp.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        var losgs = Object.values(cartResp.wirelessCart.losgs);
        if (losgs) {
            losgs.forEach(function (losg) {
                var items = Object.values(losg === null || losg === void 0 ? void 0 : losg.lineItems);
                if (items) {
                    items.forEach(function (item) {
                        var _a;
                        if (((_a = item === null || item === void 0 ? void 0 : item.hardGood) === null || _a === void 0 ? void 0 : _a.make) === 'Apple') {
                            isApple = true;
                        }
                    });
                }
            });
        }
    }
    return isApple;
}
exports.isAppleDevice = isAppleDevice;
function getPoeDetails() {
    var poeDetails = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'poeDetails');
    return poeDetails;
}
exports.getPoeDetails = getPoeDetails;
function getB2bDetails() {
    var payload = getCartResp();
    if (payload && payload.b2bDetail) {
        return payload.b2bDetail;
    }
    else {
        return null;
    }
}
exports.getB2bDetails = getB2bDetails;
function isNutritionFeatureOn() {
    return !!(isCheckoutIxpFeatureEnabled('svc-enable-nutritionlabe-flowon'));
}
exports.isNutritionFeatureOn = isNutritionFeatureOn;
function getSignatuerContractType(FANtype) {
    var signatureTypes = ['TEACHER APPRECIATION', 'Teacher Appreciation', 'TEACHER',
        'HEALTH WORKERS APPRECIATION', 'Health Workers Appreciation', 'HEALTHCARE',
        'MILITARY', 'VETERAN', 'ACTIVE & SPOUSE', 'Active & Spouse',
        'EMPLOYEE', 'Employee', 'REGULAR_IRU',
        'AARP_MEMBER', 'CONSUMER ASSOCIATION', 'Consumer Association',
        'STUDENT', 'STUDENTS',
        'UNION_MEMBER', 'MEMBER', 'Member',
        'FIRST_RESPONDER', 'FIRST RESPONDER', 'First Responder'];
    if (signatureTypes.includes(FANtype)) {
        return true;
    }
    else {
        return false;
    }
}
exports.getSignatuerContractType = getSignatuerContractType;
function isSignatureCustomer() {
    var _a;
    var b2bDetails = getB2bDetails();
    var poeDetails = getPoeDetails();
    var FANtype = (b2bDetails === null || b2bDetails === void 0 ? void 0 : b2bDetails.customerContractSubType) || ((_a = poeDetails === null || poeDetails === void 0 ? void 0 : poeDetails.segment) === null || _a === void 0 ? void 0 : _a.toUpperCase());
    return getSignatuerContractType(FANtype);
}
exports.isSignatureCustomer = isSignatureCustomer;
function purchaseorderThankyouRedirection() {
    var isSMBBBFlow = !!isSMBBBCustomerFlow();
    if (isSMBBBFlow && !!isCheckoutIxpFeatureEnabled('svc-enable-new-wireline-thankyou-page')) {
        return false;
    }
    else {
        return true;
    }
}
exports.purchaseorderThankyouRedirection = purchaseorderThankyouRedirection;
function getUserPersonalData(personalInfo) {
    return {
        firstName: (personalInfo === null || personalInfo === void 0 ? void 0 : personalInfo.fName) || '',
        lastName: (personalInfo === null || personalInfo === void 0 ? void 0 : personalInfo.lName) || '',
        emailAddress: (personalInfo === null || personalInfo === void 0 ? void 0 : personalInfo.email) || '',
        phoneNumber: (personalInfo === null || personalInfo === void 0 ? void 0 : personalInfo.phoneNo) || '',
    };
}
exports.getUserPersonalData = getUserPersonalData;
//# sourceMappingURL=UtilityFunctions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/utils/UtilityFunctions.js
// module id = 56
// module chunks = 8